import React, { useState } from "react";
import { IAutomationMail } from "../../interfaces/IAutomationMail";
import { Button, Dialog, DialogActions, DialogContent, IconButton, TableCell, TableRow } from "@mui/material";
import { IRole } from "../../interfaces/IRole";
import { Check, Close, Delete, Edit } from "@mui/icons-material";
import { AutomationMailEdit } from "./AutomationMailEdit";
import { getTmpId } from "../core/generic_helpders";

export interface IProps {
    autoMail: IAutomationMail;
    autoMailArray: IAutomationMail[];
    setAutoMailArray: Function;
    roleArray: IRole[];
}

export const getEmptyAutomationMail = (autoMailArray: IAutomationMail[], idAutomation: number): IAutomationMail => {
    return {
        is_edit_send_from: true,
        send_from: 1,
        Automation: idAutomation,
        body: "",
        id: getTmpId(autoMailArray),
        is_edit: false,
        send_just_with_UserInteraction: false,
        send_to_roles: [],
        subject: "",
        title: "",
    };
};

export const AutomationMailRow: React.FC<IProps> = ({ autoMail, autoMailArray, setAutoMailArray, roleArray }) => {
    const [editAutoMail, setEditAutoMail] = useState(autoMail);
    const [isOpenEdit, setIsOpenEdit] = useState(false);

    const handleOpen = () => {
        setEditAutoMail(autoMail);
        setIsOpenEdit(true);
    };

    const handleOnSave = () => {
        setAutoMailArray([...autoMailArray.map((mail) => (mail.id === editAutoMail.id ? editAutoMail : mail))]);
        setIsOpenEdit(false);
    };

    const handleRemoveMe = () => {
        setAutoMailArray([...autoMailArray.filter((mail) => mail.id !== editAutoMail.id)]);
    };

    return (
        <>
            {isOpenEdit && (
                <Dialog open onClose={() => setIsOpenEdit(false)} maxWidth="md" fullWidth>
                    <DialogContent>
                        <AutomationMailEdit
                            autoMail={editAutoMail}
                            setAutoMail={setEditAutoMail}
                            roleArray={roleArray}
                        />
                    </DialogContent>
                    <DialogActions>
                        <Button variant="outlined" onClick={() => setIsOpenEdit(false)}>
                            Abbruch
                        </Button>
                        <Button variant="contained" onClick={handleOnSave}>
                            Übernehmen
                        </Button>
                    </DialogActions>
                </Dialog>
            )}

            <TableRow>
                <TableCell>{autoMail.title}</TableCell>
                <TableCell>{autoMail.subject}</TableCell>
                <TableCell>{autoMail.is_edit ? <Check/> : <Close/>}</TableCell>
                <TableCell>
                    {roleArray
                        .filter((role) => autoMail.send_to_roles.includes(role.id))
                        .map((role) => role.role)
                        .join(", ")}
                </TableCell>
                <TableCell>
                    <IconButton size="small" onClick={handleOpen}>
                        <Edit />
                    </IconButton>
                    <IconButton size="small" onClick={handleRemoveMe}>
                        <Delete />
                    </IconButton>
                </TableCell>
            </TableRow>
        </>
    );
};
